import { HTTPVerbs } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';
import {
  ProfileId,
  SampleConstant,
  PlanId,
  SubscriptionId,
  API_VERSION_V1,
  ElementId,
} from './subscriptionApiConstants';

const headers = {
  'Content-Type': 'application/json',
};

export const getSampleReqObj = {
  url: `${SampleConstant}`,
  params: {},
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export function getPlansReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-plans`,
    method: HTTPVerbs.GET,
    headers: headers,
    retries: 0,
  };
}

export function getPlanDetailsReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-plans/${PlanId}`,
    method: HTTPVerbs.GET,
    headers: headers,
    retries: 0,
  };
}

export function createProfileReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-profiles`,
    method: HTTPVerbs.POST,
    headers: headers,
    retries: 0,
  };
}

export function updateProfileReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-profiles/${ProfileId}`,
    method: HTTPVerbs.PATCH,
    headers: headers,
    retries: 0,
  };
}

export function getProfileReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-profiles/${ProfileId}`,
    method: HTTPVerbs.GET,
    headers: headers,
    retries: 0,
  };
}

export function getSubscriptionReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscriptions/${SubscriptionId}`,
    method: HTTPVerbs.GET,
    headers: headers,
    retries: 0,
  };
}

export function createSubscriptionReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscriptions`,
    method: HTTPVerbs.POST,
    headers: headers,
    retries: 0,
  };
}

export function updateSubscriptionReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscriptions/${SubscriptionId}`,
    method: HTTPVerbs.PATCH,
    headers: headers,
    retries: 0,
  };
}

export function getSubscriptionProfileListReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-profiles`,
    method: HTTPVerbs.GET,
    headers: headers,
    retries: 0,
  };
}

export function getSubscriptionsReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscriptions`,
    method: HTTPVerbs.GET,
    headers: headers,
    retries: 0,
  };
}

export function getPaymentDayReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-profiles/${ProfileId}/payment-days`,
    method: HTTPVerbs.GET,
    headers: headers,
    retries: 0,
  };
}

export function getPlanCyclesReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/plan-cycles`,
    method: HTTPVerbs.GET,
    headers: headers,
    retries: 0,
  };
}

export function createPlanReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-plans`,
    method: HTTPVerbs.POST,
    headers: headers,
    retries: 0,
  };
}

export function updatePlanReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-plans/${PlanId}`,
    method: HTTPVerbs.PATCH,
    headers: headers,
    retries: 0,
  };
}

export function getElementsReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-elements`,
    method: HTTPVerbs.GET,
    headers: headers,
    retries: 0,
  };
}

export function updateElementsReqObj(): RequestOptions {
  return {
    url: `/comsubscriptionas/${API_VERSION_V1}/subscription-elements/${ElementId}`,
    method: HTTPVerbs.PATCH,
    headers: headers,
    retries: 0,
  };
}
